import cl from 'classnames';
import * as React from 'react';
import { RenderLeafProps } from 'slate-react';
import styled from 'styled-components';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  MARK_TEXT_TRANSFORM,
  TEXT_TRANSFORM_LOWER_CASE,
  TEXT_TRANSFORM_TITLE_CASE,
  TEXT_TRANSFORM_UPPER_CASE,
} from './types';

interface TextTransformPluginOptions {}

// only transform: uppercase, titlecase, lowercase
const TextTransformLeaf = styled.span`
  &.${TEXT_TRANSFORM_TITLE_CASE} {
    text-transform: capitalize;
  }
  &.${TEXT_TRANSFORM_UPPER_CASE} {
    text-transform: uppercase;
  }
  &.${TEXT_TRANSFORM_LOWER_CASE} {
    text-transform: lowercase;
  }
`;

const deserializeTextTransform = (el) => {
  if (el && el?.nodeName === 'SPAN' && el?.classList?.contains('slate-text-transform')) {
    if (el?.classList?.contains(TEXT_TRANSFORM_TITLE_CASE)) {
      return { [MARK_TEXT_TRANSFORM]: TEXT_TRANSFORM_TITLE_CASE };
    }

    if (el?.classList?.contains(TEXT_TRANSFORM_UPPER_CASE)) {
      return { [MARK_TEXT_TRANSFORM]: TEXT_TRANSFORM_UPPER_CASE };
    }

    if (el?.classList?.contains(TEXT_TRANSFORM_LOWER_CASE)) {
      return { [MARK_TEXT_TRANSFORM]: TEXT_TRANSFORM_LOWER_CASE };
    }
  }
  return undefined;
};

export const TextTransformPlugin = (options?: TextTransformPluginOptions): SlatePlugin => {
  return {
    renderLeaf: (renderProps: RenderLeafProps) => {
      const { children, leaf, ...rest } = renderProps;
      if (leaf?.[MARK_TEXT_TRANSFORM]) {
        return (
          <TextTransformLeaf
            className={cl('slate-text-transform', {
              [TEXT_TRANSFORM_TITLE_CASE]: leaf[MARK_TEXT_TRANSFORM] === TEXT_TRANSFORM_TITLE_CASE,
              [TEXT_TRANSFORM_UPPER_CASE]: leaf[MARK_TEXT_TRANSFORM] === TEXT_TRANSFORM_UPPER_CASE,
              [TEXT_TRANSFORM_LOWER_CASE]: leaf[MARK_TEXT_TRANSFORM] === TEXT_TRANSFORM_LOWER_CASE,
            })}
            {...rest}
          >
            {children}
          </TextTransformLeaf>
        );
      }

      return children;
    },
    deserialize: {
      leaf: [
        {
          type: 'text-transform',
          deserialize: deserializeTextTransform,
        },
      ],
    },
  };
};
